import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderAddRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderAddRight"><Path fillRule="evenodd" clipRule="evenodd" d="M19 13V16H22V18H19V21H17V18H14V16H17V13H19Z" fill="currentColor"/><Path d="M2 3H10.5352L12.5352 6H22V12.5278C20.9385 11.5777 19.5367 11 18 11C14.6863 11 12 13.6863 12 17C12 18.0929 12.2922 19.1175 12.8027 20H2V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderAddRight;
